import { render, staticRenderFns } from "./zoneStyle1.vue?vue&type=template&id=bb3e86ae&scoped=true&"
import script from "./zoneStyle1.vue?vue&type=script&lang=ts&"
export * from "./zoneStyle1.vue?vue&type=script&lang=ts&"
import style0 from "./zoneStyle1.vue?vue&type=style&index=0&id=bb3e86ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3e86ae",
  null
  
)

export default component.exports